import { CategoryType, DimensionSortMode } from "@digits-graphql/frontend/graphql-bearer"
import styled from "styled-components"
import { ConfigComponentContainer } from "src/frontend/components/Shared/Layout/Shared"

/*
  STYLES
*/

export const TopActivityContainer = styled(ConfigComponentContainer)`
  min-height: 300px;

  &.hidden {
    opacity: 0;
    .mobile & {
      display: none;
    }
  }
`

export enum TopActivity {
  FastestGrowing = "FastestGrowing",
  FastestShrinking = "FastestShrinking",
  Largest = "Largest",
}

export function useTopActivitySortMode(activity: TopActivity, categoryTypes: CategoryType[]) {
  const invertedSort =
    categoryTypes.includes(CategoryType.Expenses) ||
    categoryTypes.includes(CategoryType.OtherExpenses) ||
    categoryTypes.includes(CategoryType.CostOfGoodsSold)

  switch (activity) {
    case TopActivity.Largest:
      return DimensionSortMode.Total
    case TopActivity.FastestShrinking:
      return invertedSort ? DimensionSortMode.Growing : DimensionSortMode.Shrinking
    case TopActivity.FastestGrowing:
      return invertedSort ? DimensionSortMode.Shrinking : DimensionSortMode.Growing
  }
}
